<script setup lang="ts">
const { cardWidth = 190 } = defineProps<{
  cardWidth: number
}>()
</script>

<template>
  <div
    class="rounded-lg max-w-full bg-light-ui-200 dark:bg-dark-ui-200"
    :style="{ width: `${cardWidth}px`, height: `${cardWidth / 2}px` }"
  ></div>
</template>
